import { useMemo } from 'react';
import { useCustomPlanInfo } from './useCustomPlanNavigation';

export interface SetupStep {
  id: string;
  labelKey: string;
  defaultLabel: string;
  requiredByFeatures: string[];
  isEssential: boolean;
}

export const ALL_SETUP_STEPS: SetupStep[] = [
  {
    id: 'welcome',
    labelKey: 'setupGuide.steps.welcome',
    defaultLabel: 'Welcome',
    requiredByFeatures: [],
    isEssential: true,
  },
  {
    id: 'default-currency',
    labelKey: 'setupGuide.steps.defaultCurrency',
    defaultLabel: 'Default Currency',
    requiredByFeatures: [],
    isEssential: true,
  },
  {
    id: 'completed',
    labelKey: 'setupGuide.steps.completed',
    defaultLabel: 'Completed',
    requiredByFeatures: [],
    isEssential: true,
  },
];

export function useSetupStepsConfig() {
  const { data: customPlanInfo, isLoading } = useCustomPlanInfo();

  const steps = useMemo(() => {
    return ALL_SETUP_STEPS;
  }, []);

  return {
    steps,
    isLoading,
    isCustomPlan: customPlanInfo?.isCustomPlan || false,
    featureKeys: customPlanInfo?.featureKeys || [],
  };
}

export function getStepLabel(step: SetupStep, t: (key: string, fallback: string) => string): string {
  return t(step.labelKey, step.defaultLabel);
}
